function TextArea({
  label,
  name,
  value,
  onChange,
  placeholder,
  rows = 4,
  error,
  hint,
  className = "",
  labelClassName = "",
  ...props
}) {
  return (
    <label className="block space-y-1">
      {label && (
        <span className={`text-[11px] font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 ${labelClassName}`.trim()}>
          {label}
        </span>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        {...props}
        className={`w-full rounded-lg border bg-white px-3 py-1.5 text-xs text-slate-900 focus:outline-none transition-all placeholder:text-slate-400 focus:ring-2 dark:bg-slate-900 dark:text-slate-100 ${
          error
            ? "border-danger focus:border-danger focus:ring-danger/20"
            : "border-slate-200 focus:border-primary-500 focus:ring-primary-500/20 dark:border-slate-800 dark:focus:border-primary-500 dark:focus:ring-primary-dark/20"
        } ${className}`.trim()}
      />
      {error ? (
        <p className="mt-1 text-xs font-medium text-danger">{error}</p>
      ) : hint ? (
        <p className="mt-1 text-xs text-brand-text-secondary dark:text-slate-400">{hint}</p>
      ) : null}
    </label>
  );
}

export default TextArea;
